<template>
  <div class="main">
    <div class="list-bg">
      <img :src="bkimg" alt="">
    </div>
    <div class="contain">
      <div class="contain-title"><img src="../assets/partners-title1.png" alt=""></div>
      <div class="contain-partners-logos">
        <a :href="item.url" v-for="(item,index) in logos" :key="index" target="='_blank">
          <img class="contain-partners-logo"  :src="item.img" alt="">
        </a>
      </div>
      <div class="contain-title"><img src="../assets/partners-title2.png" alt=""></div>
      <div class="contain-lists">
        <div class="contain-list" v-for="(item,index) in lists" :key="index">
          <img class="contain-list-left" :src="item.listImg" alt="">
          <div class="contain-list-right">
            <div class="list-right1">{{item.title}}</div>
            <div class="list-right2">{{item.introduce}}</div>
            <div class="list-right3">
              <div style="color:rgba(0,128,204,1);cursor:pointer;"  @click='gotodetail(item)'>阅读原文>></div>
              <div class="right3-right">
                <img style="width:17px;height:13px;" src="../assets/freeRunning-eye.png" alt="">&nbsp;&nbsp;<span style="margin-right:15px;">{{item.clickNum}}</span>
                <img style="width:13px;height:13px;" src="../assets/freeRunning-time.png" alt=""> &nbsp;&nbsp;<span>{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>
<script>
import Banner2 from '../views/Index/banner2'
import {getPartnersLogo, getPartnersList} from '@/api/partners.js'
import { formateDateNumber } from '@/utils/index.js'
// import {getthemelist} from '@/api/theme.js'
import bkimg from '../assets/news-back.png'
export default {
  data () {
    return {
      lists: [],
      logos: [],
      querylist: {
        page: 1,
        limit: 15
      },
      total: undefined,
      bkimg: bkimg,
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperList: [{'img': 'https://tripolers.com.cn/admin/storage/fetch/etdt5vljp6wc2upsxrxc.jpg'}, {'img': 'https://tripolers.com.cn/admin/storage/fetch/oujhr4165jzwqtws51ns.jpg'}, {'img': 'https://tripolers.com.cn/admin/storage/fetch/lqvl034xr7tp61qelnh8.jpg'}, {'img': 'https://tripolers.com.cn/admin/storage/fetch/rnhh8ozjt2i6uuabifx7.jpg'}]
    }
  },
  components: {
    Banner2
  },
  methods: {
    // 点击加载更多
    more () {
      this.querylist.page += 1
      this.getlist()
    },
    // 跳转详情页
    gotodetail (item) {
      this.$router.push({
        name: 'PastReviewDetail',
        params: {
          partnerId: item.id,
          img: item.listImg,
          title: item.title
        }
      })
    },
    getlist () {
      getPartnersList(this.querylist).then(res => {
        let items = res.data.data.items
        items.forEach(element => {
          element.addTime = formateDateNumber(element.addTime)
        })
        this.lists = this.lists.concat(items)
        console.log(this.lists)
        this.total = res.data.data.total
      })
    },
    getLogo () {
      getPartnersLogo(this.querylist).then(res => {
        this.logos = this.logos.concat(res.data.data.items)
      })
    }

  },
  mounted () {
    this.lists = []
  },
  created () {
    this.getlist()
    this.getLogo()
    if (this.$route.query.img) {
      this.bkimg = this.$route.query.img
    }
  }
}
</script>
<style scoped>
.main{
      background-color:#f4f4f4;
      padding-bottom:1.5rem;
  }
  .list-bg {
        width: 100%;
        height: 672px;
        /* background: url(../assets/news-back.png) no-repeat center; */
        background-size: cover;
    }
  .list-bg img{
    width:100%;
    height: 672px;

  }
  .contain{
    width:80rem;
    background-color: #fff;
    padding-bottom:3.75rem;
    padding-top:59px;
    margin: -200px auto 0;
    position: relative;
  }
  .contain-title{
    width:1032px;
    margin:0 auto;
    margin-bottom:53px;
  }
  .contain-partners-logos{
    padding:0 24px;
    display:flex;
    flex-wrap: wrap;
    margin-bottom:57px;
  }
  .contain-partners-logo{
    width:233px;
    height:140px;
    margin-bottom:16px;
    margin-right:13px;
  }
  .contain-lists{
    padding:0 24px;
  }
  .contain-list{
    width:100%;
    height:194px;
    background:rgba(250,250,250,1);
    margin-bottom:24px;
    display:flex;
    padding:19px 24px;
    box-sizing: border-box;
  }
  .contain-list-left{
    width:209px;
    margin-right:25px;
  }
  .contain-list-right{
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    width:100%;
    /* align-items: left; */
  }
  .list-right1{
    font-size:18px;
    font-family:Source Han Sans CN;
    font-weight:400;
    color:rgba(59,62,64,1);
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;  /*要显示的行数*/
    -webkit-box-orient: vertical;
  }
  .list-right2{
    margin-top:-40px;
    font-size:14px;
    font-family:Source Han Sans CN;
    font-weight:300;
    color:rgba(121,129,135,1);
    height:60px;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;  /*要显示的行数*/
    -webkit-box-orient: vertical;
  }
  .list-right3{
    display:flex;
    justify-content: space-between;
    align-items: center;
    font-size:14px;
    font-family:Source Han Sans CN;
    font-weight:300;
    /* color:rgba(0,128,204,1); */
  }
  .right3-right{
    display:flex;
    align-items: center;
  }
  .right3-right span{
    line-height: 1;
  }
</style>



// WEBPACK FOOTER //
// src/views/partners.vue